import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import { Col, Row } from 'react-bootstrap';
import Utils from './Utils';
import pubSub from '../../PubSub';
import _ from 'underscore';
import {toggleLead, getPersonById, sendActivities} from '../../actions/UserProfileActions';
import { fetchAllPersons } from '../../actions/CommunityActions';
import TwitterWidgetView from './TwitterWidgetView';
import CommunityUserSocialBoxView from './CommunityUserSocialBoxView';
import CommunityUserLinkedinDataView from './CommunityUserLinkedinDataView';
import ImageOrLettersView from './ImageOrLettersView';
import { getInternalWebsiteBaseUrl } from 'web-common/scripts/utils/whitelabelUtils';


function mapStateToProps(state, props) {
    const {userProfilePageReducer, personsReducer, meReducer, eventReducer, siteConfReducer} = state;
    const persons = personsReducer.persons || [];
    const personArr = persons.filter((person) => (props.personId == person.id));
    const person = personArr[0] || {};
    const linkedinData = person.linkedinProfile || '{}';
    const parsedLinkedinData = JSON.parse(linkedinData);
    const personWithLinkedinData = {
        linkedinInfo: parsedLinkedinData,
        ...person
    };

    return {
        event: eventReducer.event,
        me: meReducer.me,
        siteConf: siteConfReducer.siteConf,
        isLoading: userProfilePageReducer.isLoading,
        persons: persons,
        person: personWithLinkedinData,
        isLinkedInTokenValid: meReducer.isLinkedInTokenValid
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleLead,
        getPersonById,
        fetchAllPersons,
        sendActivities
    }, dispatch);
}

class CommunityUserProfile extends Component {

    componentDidMount() {
        this.getUserProfileData();

        let user = this.props.person || {};
        let isMe = this.props.me.id === user.id;
        if (!isMe) {
            pubSub.publish('analytics:ViewedProfile', this.props.person.id, this.props.person.firstName + ' ' + this.props.person.lastName);
            this.props.sendActivities({
                eventId: this.props.event.id,
                entity: 'person',
                id: user.id
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isLinkedInTokenValid !== this.props.isLinkedInTokenValid) {
            if (this.props.isLinkedInTokenValid) {
                this.getUserProfileData();
            }
        }
    }

    getUserProfileData() {
        this.props.getPersonById({
            personId: this.props.personId,
            eventId: this.props.event && this.props.event.id
        });
    }


    toggleLead = () => {
        this.props.toggleLead({
            personId: this.props.personId,
            fullName: Utils.getFullName(this.props.person.firstName, this.props.person.lastName),
            eventId: this.props.event && this.props.event.id,
            myLead: this.props.person.myLead
        });
    }

    clickedBack = (e) => {
        if (this.props.persons.length === 1) {
            this.props.fetchAllPersons({
                eventId: this.props.event.id
            });
        } else {
            window.history.back();
            e.preventDefault();
        }
    }

    render() {
        const {person, isLoading, me, event} = this.props;
        const user = person || {};
        const oneLiner = user.oneLiner ? '"' + user.oneLiner + '"' : '';
        const cx = classnames;
        const isLoadingCls = cx('col-xs-12 spinner-container text-center', {'hide': !isLoading});
        const hideContainer = cx('', {'hide': isLoading});
        const markedAsLead = cx('mark-as-lead-button-user-profile button-user-profile color-1', {'mark-as-lead-enabled color-1-background': user.myLead});
        const markedAsLeadText = cx('no-style-link-button text-color-default font-normal no-style-link-button margin-left-small', {'color-1': user.myLead});
        const isMe = me.id === user.id;
        const profileButtons = cx('margin-bottom-medium margin-top-small color-1', {'hide': isMe});
        const hideIfIsMe = cx('separator margin-top-medium ', {'hide': isMe});
        const experienceSection = cx('experience-section col-xs-12', {'col-sm-8': user['twitter-handle']});
        const twitterSection = cx('twitter-section', {'hide': !user['twitter-handle'], 'col-sm-4 col-xs-12': user['twitter-handle']});
        const sendMessageURL = getInternalWebsiteBaseUrl(event, 'inbox/' + person.id);

        return <div className="user-profile-container container padding-left-none padding-right-none make-relative">
            <div className={isLoadingCls}><i className="fa fa-spinner fa-spin"/></div>
            <div className={hideContainer}>
                <div className="upper-profile-block">
                    <Link to={getInternalWebsiteBaseUrl(this.props.event, 'community')} className="text-color-default"
                        onClick={this.clickedBack}>
                        <Col
                            className="button-user-profile back-to-community-button margin-top-small pull-left margin-left-none">
                            <span className="text-wrapper make-relative">
                        BACK
                            </span>
                        </Col>
                    </Link>
                </div>
                <div className="lower-profile-block">
                    <div
                        className={Utils.getImageShapeClassName('image-wrapper color-1 user-profile-image-wrapper', this.props.siteConf.template)}>
                        <div
                            className={Utils.getImageShapeClassName('image-holder user-profile-image-holder', this.props.siteConf.template)}>
                            <ImageOrLettersView image={user.photoUrl} firstName={user.firstName}
                                lastName={user.lastName}
                                shape={Utils.getImageShapeClassName(null, this.props.siteConf.template)}/>
                        </div>
                    </div>
                    <div className="user-profile-header">{user.firstName} {user.lastName}</div>
                    <div className="user-profile-sub-header">{user.title}</div>
                    <div className="user-profile-sub-header">{user.company}</div>
                    <div className="user-profile-one-liner color-1 padding-bottom-small">{oneLiner}</div>
                    <div className={profileButtons}>
                        <span className="send-message-button-user-profile button-user-profile color-1">
                            <span className="text-wrapper make-relative">
                                <i className="fa icon-community_mail user-profile-button-icon community-list-item-buttons-icon color-1"/>
                                <Link to={sendMessageURL}><span
                                    className="text-color-default font-normal margin-left-small">SEND MESSAGE</span></Link>
                            </span>
                        </span>
                        <span className={markedAsLead} onClick={() => this.toggleLead()}>
                            <span className="text-wrapper make-relative">
                                <i className="fa icon-community_star user-profile-button-icon community-list-item-buttons-icon color-1"/>
                                <button className={markedAsLeadText}>STAR</button>
                            </span>
                        </span>
                    </div>
                    <div className={hideIfIsMe} />
                    <Row className="padding-bottom-large margin-horizontal-none">
                        <div className="social-section padding-horizontal-none">
                            <CommunityUserSocialBoxView user={user} />
                        </div>
                        <div className="experience-and-twitter-container">
                            <Col className={experienceSection}>
                                {
                                    user.summary &&
                                    <div className="detail-item-container color-1-border padding-top-small">
                                        <span className="make-relative">
                                            <i className="icon icon-registration detail-icon" />
                                        </span>
                                        <span className="experience-title padding-left-small">Summary</span>
                                        <div className="padding-left-small">{user.summary}</div>
                                    </div>
                                }
                                <CommunityUserLinkedinDataView user={user} />
                            </Col>
                            <Col className={twitterSection}>
                                <TwitterWidgetView twitterHandle={user['twitter-handle']}/>
                            </Col>
                        </div>
                    </Row>
                </div>
            </div>
        </div>;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CommunityUserProfile);
